"use strict";

// Name must be unique and is showed to user if they can manage permissions
// (type: 'manageable')
// Otherwise required but meaningless
//
// CODE must be unique and is used in front to prevent updating every href when a route is changed

module.exports.routes = [{
  name: 'Sitemap',
  back: {
    url: '/sitemap.xml',
    controller: 'SitemapController',
    action: 'generate',
    skipAssets: false
  },
  type: 'public'
}, {
  name: 'fetchMetas',
  back: {
    url: 'POST /fetch-metas',
    controller: 'RouteController',
    action: 'fetchMetas'
  },
  type: 'public'
},
/*
	========================================================
	------------------------- Front ------------------------
	========================================================
*/
{
  name: 'GET /',
  CODE: 'Home',
  front: {
    url: '/',
    reactComponent: 'HomePage'
  },
  sitemap: {
    priority: 1
  },
  type: 'public'
}, {
  name: 'GET /candidat',
  CODE: 'InfoCandidate',
  front: {
    url: '/candidat',
    reactComponent: 'InfoCandidatePage'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /recruteurs',
  CODE: 'InfoCompany',
  front: {
    url: '/recruteurs',
    reactComponent: 'InfoCompanyPage'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /faire-un-don',
  CODE: 'Donate',
  front: {
    url: '/faire-un-don',
    reactComponent: 'DonatePage'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /devenez-benevole',
  CODE: 'BecomeVolonteer',
  front: {
    url: '/devenez-benevole',
    reactComponent: 'BecomeVolonteer'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /recrutement-et-integration',
  CODE: 'Recrutement',
  front: {
    url: '/recrutement-et-integration',
    reactComponent: 'RecrutementPage'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /preparation-a-l-emploi',
  CODE: 'PreparationEmploi',
  front: {
    url: '/preparation-a-l-emploi',
    reactComponent: 'PreparationEmploiPage'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /formation-sensibilisation',
  CODE: 'FormationSensibilisation',
  front: {
    url: '/formation-sensibilisation',
    reactComponent: 'FormationSensibilisationPage'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /maintien-emploi',
  CODE: 'MaintienEmploi',
  front: {
    url: '/maintien-emploi',
    reactComponent: 'MaintienEmploiPage'
  },
  sitemap: {
    priority: 0.5
  },
  type: 'public'
}, {
  name: 'GET /ressources',
  CODE: 'Ressources',
  front: {
    url: '/ressources',
    reactComponent: 'RessourcesPage'
  },
  type: 'public'
}, {
  name: 'GET /actualites',
  CODE: 'FrontNews',
  front: {
    url: '/actualites',
    reactComponent: 'FrontNewsPage'
  },
  type: 'public'
}, {
  name: 'GET /actualites/:slug',
  CODE: 'FrontNewsDetails',
  front: {
    url: '/actualites/:slug',
    reactComponent: 'FrontNewsDetailsPage'
  },
  type: 'public'
}, {
  name: 'GET /candidats',
  CODE: 'CandidateList',
  front: {
    url: '/candidats',
    reactComponent: 'CandidateListPage'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'GET /candidats/:id',
  CODE: 'CandidateListDetails',
  front: {
    url: '/candidats/:id',
    reactComponent: 'CandidateListDetailsPage'
  },
  type: 'manageable',
  roles: ['company', 'candidate']
}, {
  name: 'GET /annonces',
  CODE: 'JobAdsFrontList',
  front: {
    url: '/annonces',
    reactComponent: 'JobAdsFrontListPage'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'GET /annonces/:id',
  CODE: 'JobAdsFrontListDetails',
  front: {
    url: '/annonces/:id',
    reactComponent: 'JobAdsFrontListDetailsPage'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'GET /mentions-legales',
  CODE: 'MentionsLegales',
  front: {
    url: '/mentions-legales',
    reactComponent: 'MentionsLegalesPage'
  },
  type: 'public'
}, /* ------------------------- Candidate ------------------------- */
{
  name: 'GET /inscription-candidat',
  CODE: 'NewCandidateFront',
  front: {
    url: '/inscription-candidat',
    reactComponent: 'NewCandidateFrontPage'
  },
  type: 'public'
}, {
  name: 'GET /mon-compte-candidat',
  CODE: 'CandidateAccount',
  front: {
    url: '/mon-compte-candidat',
    reactComponent: 'CandidateAccountPage'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'GET /mon-cv',
  CODE: 'CandidateCV',
  front: {
    url: '/mon-cv',
    reactComponent: 'CandidateCvPage'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'GET /modifier-mon-compte-candidat',
  CODE: 'UpdateCandidateAccount',
  front: {
    url: '/modifier-mon-compte-candidat',
    reactComponent: 'CandidateUpdateAccountPage'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'GET /modifier-mon-dossier',
  CODE: 'CandidateUpdateRecord',
  front: {
    url: '/modifier-mon-dossier',
    reactComponent: 'CandidateUpdateRecordPage'
  },
  type: 'manageable',
  roles: ['candidate']
}, /* ------------------------- Company ------------------------- */
{
  name: 'GET /inscription-entreprise',
  CODE: 'NewCompanyFront',
  front: {
    url: '/inscription-entreprise',
    reactComponent: 'NewCompanyFrontPage'
  },
  type: 'public'
}, {
  name: 'GET /mon-compte-entreprise',
  front: {
    url: '/mon-compte-entreprise',
    reactComponent: 'CompanyAccountPage'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'GET /modifier-mon-compte-entreprise',
  front: {
    url: '/modifier-mon-compte-entreprise',
    reactComponent: 'CompanyUpdateAccountPage'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'GET /mes-annonces/:id',
  front: {
    url: '/mes-annonces/:id',
    reactComponent: 'JobAdCompanyPage'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'GET /creer-une-annonce',
  front: {
    url: '/creer-une-annonce',
    reactComponent: 'NewJobAdPage'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'GET /modifier-annonce/:id',
  front: {
    url: '/modifier-annonce/:id',
    reactComponent: 'UpdateJobAdPage'
  },
  type: 'manageable',
  roles: ['company']
},
/*
	========================================================
	------------------------- Back -------------------------
	========================================================
*/
{
  name: 'GET /accueil',
  CODE: 'UserHomePage',
  front: {
    url: '/accueil',
    reactComponent: 'WelcomePage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, /* ------------------------- User ------------------------- */

{
  name: 'GET /configuration/liste-des-utilisateurs',
  CODE: 'AdminUsersDashboard',
  front: {
    url: '/configuration/liste-des-utilisateurs',
    reactComponent: 'UsersDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /configuration/liste-des-utilisateurs/nouvel-utilisateur',
  CODE: 'NewUser',
  front: {
    url: '/configuration/liste-des-utilisateurs/nouvel-utilisateur',
    reactComponent: 'NewUserPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /configuration/liste-des-utilisateurs/:id',
  front: {
    url: '/configuration/liste-des-utilisateurs/:id',
    reactComponent: 'UpdateUserPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /user/get-all',
  back: {
    url: 'POST /user/get-all',
    controller: 'UserController',
    action: 'getAll'
  },
  type: 'manageable',
  roles: ['admin', 'agent', 'accompanist', 'companies-manager']
}, {
  name: 'POST /user/create',
  back: {
    url: 'POST /user/create',
    controller: 'UserController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /user/update',
  back: {
    url: 'POST /user/update',
    controller: 'UserController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'DELETE /user/delete',
  back: {
    url: 'DELETE /user/delete',
    controller: 'UserController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, /* ------------------------- Sector ------------------------- */
{
  name: 'GET /configuration/liste-des-secteurs',
  CODE: 'AdminSectorsDashboard',
  front: {
    url: '/configuration/liste-des-secteurs',
    reactComponent: 'SectorsDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /configuration/liste-des-secteurs/nouveau-secteur',
  CODE: 'NewSector',
  front: {
    url: '/configuration/liste-des-secteurs/nouveau-secteur',
    reactComponent: 'NewSectorPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /configuration/liste-des-secteurs/:id',
  front: {
    url: '/configuration/liste-des-secteurs/:id',
    reactComponent: 'UpdateSectorPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /sector/get-all',
  back: {
    url: 'POST /sector/get-all',
    controller: 'SectorController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /sector/create',
  back: {
    url: 'POST /sector/create',
    controller: 'SectorController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /sector/update',
  back: {
    url: 'POST /sector/update',
    controller: 'SectorController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'DELETE /sector/delete',
  back: {
    url: 'DELETE /sector/delete',
    controller: 'SectorController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, /* ------------------------- Candidate ------------------------- */

{
  name: 'GET /liste-des-candidats',
  CODE: 'AdminCandidatesDashboard',
  front: {
    url: '/liste-des-candidats',
    reactComponent: 'CandidatesDashboardPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'GET /liste-des-candidats/nouveau-candidat',
  CODE: 'NewCandidate',
  front: {
    url: '/liste-des-candidats/nouveau-candidat',
    reactComponent: 'NewCandidatePage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'GET /liste-des-candidats/:id',
  front: {
    url: '/liste-des-candidats/:id',
    reactComponent: 'UpdateCandidatePage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'POST /candidate/get-all',
  back: {
    url: 'POST /candidate/get-all',
    controller: 'CandidateController',
    action: 'getAll'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'super_admin']
}, {
  name: 'POST /candidate/get-self',
  back: {
    url: 'POST /candidate/get-self',
    controller: 'CandidateController',
    action: 'getSelf'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'POST /candidate/create',
  back: {
    url: 'POST /candidate/create',
    controller: 'CandidateController',
    action: 'create'
  },
  type: 'public'
}, {
  name: 'POST /candidate/update',
  back: {
    url: 'POST /candidate/update',
    controller: 'CandidateController',
    action: 'update'
  },
  type: 'public'
}, {
  name: 'POST /candidate/update-my-infos',
  back: {
    url: 'POST /candidate/update-my-infos',
    controller: 'CandidateController',
    action: 'updateMyInfos'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'POST /candidate/update-my-record',
  back: {
    url: 'POST /candidate/update-my-record',
    controller: 'CandidateController',
    action: 'updateMyRecord'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'DELETE /candidate/delete',
  back: {
    url: 'DELETE /candidate/delete',
    controller: 'CandidateController',
    action: 'delete'
  },
  type: 'manageable',
  roles: ['agent', 'admin']
}, {
  name: 'POST /candidate/send-account-comment',
  back: {
    url: "POST /candidate/send-account-comment",
    controller: 'CandidateController',
    action: 'sendAccountComment'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'POST /candidate/company-interest',
  back: {
    url: "POST /candidate/company-interest",
    controller: 'CandidateController',
    action: 'sendCompanyInterest'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'GET /validation-charte/:id',
  front: {
    url: '/validation-charte/:id',
    reactComponent: 'ValidateCandidatePage'
  },
  type: 'public'
}, {
  name: 'POST /candidate/validate-candidate-account',
  back: {
    url: "POST /candidate/validate-candidate-account",
    controller: 'CandidateController',
    action: 'validateAccount'
  },
  type: 'public'
}, {
  name: 'GET /telechargements/candidat',
  back: {
    url: 'GET /telechargements/candidat',
    controller: 'CandidateController',
    action: 'exportCandidates',
    skipAssets: false
  },
  type: 'manageable',
  roles: ['admin']
}, {
  name: 'POST /candidate/get-candidate-count-by-status',
  back: {
    url: 'POST /candidate/get-candidate-count-by-status',
    controller: 'CandidateController',
    action: 'getCandidateCountByStatus'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'POST /candidate/get-candidate-count-by-support-status',
  back: {
    url: 'POST /candidate/get-candidate-count-by-support-status',
    controller: 'CandidateController',
    action: 'getCandidateCountBySupportStatus'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: "fetchCVDownloaded",
  back: {
    url: "GET /uploaded/cv-download/:candidateId/:name",
    controller: "CandidateController",
    action: "fetchCVDownloaded",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchTsaFile",
  back: {
    url: "GET /uploaded/tsa_diagnostic/:candidateId/:name",
    controller: "CandidateController",
    action: "fetchTsaFile",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchRqthFile",
  back: {
    url: "GET /uploaded/rqth/:candidateId/:name",
    controller: "CandidateController",
    action: "fetchRqthFile",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchMonitoringFile",
  back: {
    url: "GET /uploaded/monitoring/:candidateId/:name",
    controller: "CandidateController",
    action: "fetchMonitoringFile",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchActionListFile",
  back: {
    url: "GET /uploaded/action-list/:candidateId/:name",
    controller: "CandidateController",
    action: "fetchActionListFile",
    skipAssets: false
  },
  type: "public"
}, {
  name: 'POST /candidate/get-all-departments',
  back: {
    url: "POST /candidate/get-all-departments",
    controller: 'CandidateController',
    action: 'getAllCandidatesDepartments'
  },
  type: 'manageable',
  roles: "public"
}, /* ------------------------- Company ------------------------- */

{
  name: 'GET /liste-des-entreprises',
  CODE: 'AdminCompaniesDashboard',
  front: {
    url: '/liste-des-entreprises',
    reactComponent: 'CompaniesDashboardPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, {
  name: 'GET /liste-des-entreprises/nouvelle-entreprise',
  CODE: 'NewCompany',
  front: {
    url: '/liste-des-entreprises/nouvelle-entreprise',
    reactComponent: 'NewCompanyPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, {
  name: 'GET /liste-des-entreprises/:id',
  front: {
    url: '/liste-des-entreprises/:id',
    reactComponent: 'UpdateCompanyPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, {
  name: 'POST /company/get-all',
  back: {
    url: 'POST /company/get-all',
    controller: 'CompanyController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /company/get-mine',
  back: {
    url: 'POST /company/get-mine',
    controller: 'CompanyController',
    action: 'getMine'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'POST /company/create',
  back: {
    url: 'POST /company/create',
    controller: 'CompanyController',
    action: 'create'
  },
  type: 'public'
}, {
  name: 'POST /company/update',
  back: {
    url: 'POST /company/update',
    controller: 'CompanyController',
    action: 'update'
  },
  type: 'public'
}, {
  name: 'POST /company/update-mine',
  back: {
    url: 'POST /company/update-mine',
    controller: 'CompanyController',
    action: 'updateMine'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'GET /telechargements/entreprises',
  back: {
    url: 'GET /telechargements/entreprises',
    controller: 'CompanyController',
    action: 'exportCompanies',
    skipAssets: false
  },
  type: 'manageable',
  roles: ['agent', 'admin']
}, {
  name: 'DELETE /company/delete',
  back: {
    url: 'DELETE /company/delete',
    controller: 'CompanyController',
    action: 'delete'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, {
  name: "fetchMonitoringFile",
  back: {
    url: "GET /uploaded/monitoring/:companyId/:name",
    controller: "CompanyController",
    action: "fetchMonitoringFile",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchCompanyLogo",
  back: {
    url: "GET /uploaded/logo/:companyId/:name",
    controller: "CompanyController",
    action: "fetchCompanyLogo",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchCompanyCustomerProposal",
  back: {
    url: "GET /uploaded/proposition/:companyId/:name",
    controller: "CompanyController",
    action: "fetchCompanyCustomerProposal",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchCompanyCustomerProposalAccepted",
  back: {
    url: "GET /uploaded/proposition-acceptee/:companyId/:name",
    controller: "CompanyController",
    action: "fetchCompanyCustomerProposalAccepted",
    skipAssets: false
  },
  type: "public"
}, {
  name: 'POST /company/update-account-status',
  back: {
    url: "POST /company/update-account-status",
    controller: 'CompanyController',
    action: 'updateAccountStatus'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, /* ------------------------- CompanyActivity ------------------------- */

{
  name: 'GET /configuration/liste-des-activites',
  CODE: 'CompanyActivities',
  front: {
    url: '/configuration/liste-des-activites',
    reactComponent: 'CompanyActivitiesDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /company-activity/get-all',
  back: {
    url: 'POST /company-activity/get-all',
    controller: 'CompanyActivityController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /company-activity/create',
  back: {
    url: 'POST /company-activity/create',
    controller: 'CompanyActivityController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /company-activity/update',
  back: {
    url: 'POST /company-activity/update',
    controller: 'CompanyActivityController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'DELETE /company-activity/delete',
  back: {
    url: 'DELETE /company-activity/delete',
    controller: 'CompanyActivityController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, /* ------------------------- JobAd ------------------------- */

{
  name: 'GET /liste-des-annonces',
  CODE: 'AdminJobAdsDashboard',
  front: {
    url: '/liste-des-annonces',
    reactComponent: 'JobAdsDashboardPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, {
  name: 'GET /liste-des-annonces/nouvelle-annonce',
  CODE: 'NewJobAdBack',
  front: {
    url: '/liste-des-annonces/nouvelle-annonce',
    reactComponent: 'NewJobAdBackPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, {
  name: 'GET /liste-des-annonces/:id',
  front: {
    url: '/liste-des-annonces/:id',
    reactComponent: 'UpdateJobAdBackPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist', 'companies-manager']
}, {
  name: 'POST /job-ad/get-all',
  back: {
    url: 'POST /job-ad/get-all',
    controller: 'JobAdController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /job-ad/create',
  back: {
    url: 'POST /job-ad/create',
    controller: 'JobAdController',
    action: 'create'
  },
  type: 'public'
}, {
  name: 'POST /job-ad/update',
  back: {
    url: 'POST /job-ad/update',
    controller: 'JobAdController',
    action: 'update'
  },
  type: 'public'
}, {
  name: 'POST /jobad/postulation-notif',
  back: {
    url: 'POST /jobad/postulation-notif',
    controller: 'JobAdController',
    action: 'sendPostulationNotif'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'POST /job-ad/get-company-ad',
  back: {
    url: 'POST /job-ad/get-company-ad',
    controller: 'JobAdController',
    action: 'fetchJobAdByCompany'
  },
  type: 'public'
}, {
  name: 'DELETE /job-ad/delete',
  back: {
    url: 'DELETE /job-ad/delete',
    controller: 'JobAdController',
    action: 'delete'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'company']
}, {
  name: 'POST /jobad/get-all-with-company',
  back: {
    url: 'POST /jobad/get-all-with-company',
    controller: 'JobAdController',
    action: 'getAllWithCompany'
  },
  type: 'public'
}, /* ------------------------- ProfessionalDomain ------------------------- */

{
  name: 'GET /configuration/liste-des-domaines-professionnels',
  CODE: 'ProfessionalDomains',
  front: {
    url: '/configuration/liste-des-domaines-professionnels',
    reactComponent: 'ProfessionalDomainsDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /professional-domain/get-all',
  back: {
    url: 'POST /professional-domain/get-all',
    controller: 'ProfessionalDomainController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /professional-domain/create',
  back: {
    url: 'POST /professional-domain/create',
    controller: 'ProfessionalDomainController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /professional-domain/update',
  back: {
    url: 'POST /professional-domain/update',
    controller: 'ProfessionalDomainController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'DELETE /professional-domain/delete',
  back: {
    url: 'DELETE /professional-domain/delete',
    controller: 'ProfessionalDomainController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, /* ------------------------- CV ------------------------- */

{
  name: 'GET /liste-des-cvs',
  CODE: 'AdminCVDashboard',
  front: {
    url: '/liste-des-cvs',
    reactComponent: 'AdminCVDashboardPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'GET /liste-des-cvs/nouveau-cv',
  CODE: 'NewCVBack',
  front: {
    url: '/liste-des-cvs/nouveau-cv',
    reactComponent: 'NewCVBackPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'GET /liste-des-cvs/:id',
  CODE: 'UpdateCVBack',
  front: {
    url: '/liste-des-cvs/:id',
    reactComponent: 'UpdateCVBackPage'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'POST /cv/get-all',
  back: {
    url: 'POST /cv/get-all',
    controller: 'CvController',
    action: 'getAll'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'accompanist']
}, {
  name: 'POST /cv/get-mine',
  back: {
    url: 'POST /cv/get-mine',
    controller: 'CvController',
    action: 'getMine'
  },
  type: 'manageable',
  roles: ['candidate']
}, {
  name: 'POST /cv/create',
  back: {
    url: 'POST /cv/create',
    controller: 'CvController',
    action: 'create'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'candidate', 'accompanist']
}, {
  name: 'POST /cv/update',
  back: {
    url: 'POST /cv/update',
    controller: 'CvController',
    action: 'update'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'candidate', 'accompanist']
}, {
  name: 'GET /cv/:cv_id/CV',
  back: {
    url: 'GET /cv/:cv_id/CV',
    controller: 'CvController',
    action: 'downloadPdf'
  },
  type: 'manageable',
  roles: ['agent', 'admin', 'candidate', 'accompanist']
}, {
  name: 'POST /cv/get-all-with-candidate',
  back: {
    url: 'POST /cv/get-all-with-candidate',
    controller: 'CvController',
    action: 'getCandidateWithCV'
  },
  type: 'manageable',
  roles: ['company', 'candidate']
}, /* ------------------------- Testimonies ------------------------- */
{
  name: 'GET /contenu/liste-des-temoignages',
  CODE: 'TestimoniesDashboardPage',
  front: {
    url: '/contenu/liste-des-temoignages',
    reactComponent: 'TestimoniesDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /contenu/liste-des-temoignages/nouveau-temoignage',
  CODE: 'NewTestimonyPage',
  front: {
    url: '/contenu/liste-des-temoignages/nouveau-temoignage',
    reactComponent: 'NewTestimonyPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /contenu/liste-des-temoignages/modifier-temoignage/:id',
  CODE: 'UpdateTestimonyPage',
  front: {
    url: '/contenu/liste-des-temoignages/modifier-temoignage/:id',
    reactComponent: 'UpdateTestimonyPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /testimony/get-all',
  back: {
    url: 'POST /testimony/get-all',
    controller: 'TestimonyController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /testimony/create',
  back: {
    url: 'POST /testimony/create',
    controller: 'TestimonyController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /testimony/update',
  back: {
    url: 'POST /testimony/update',
    controller: 'TestimonyController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'DELETE /testimony/delete',
  back: {
    url: 'DELETE /testimony/delete',
    controller: 'TestimonyController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, /* ------------------------- Partners ------------------------- */
{
  name: 'GET /contenu/liste-des-partenaires',
  CODE: 'PartnersDashboardPage',
  front: {
    url: '/contenu/liste-des-partenaires',
    reactComponent: 'PartnersDashboardPage'
  },
  type: 'notManageable'
}, {
  name: 'GET /contenu/liste-des-partenaires/nouveau-partenaire',
  CODE: 'NewPartnerPage',
  front: {
    url: '/contenu/liste-des-partenaires/nouveau-partenaire',
    reactComponent: 'NewPartnerPage'
  },
  type: 'notManageable'
}, {
  name: 'GET /contenu/liste-des-partenaires/modifier-partenaire/:id',
  CODE: 'UpdatePartnerPage',
  front: {
    url: '/contenu/liste-des-partenaires/modifier-partenaire/:id',
    reactComponent: 'UpdatePartnerPage'
  },
  type: 'notManageable'
}, {
  name: 'POST /partner/get-all',
  back: {
    url: 'POST /partner/get-all',
    controller: 'PartnerController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /partner/create',
  back: {
    url: 'POST /partner/create',
    controller: 'PartnerController',
    action: 'create'
  },
  type: 'notManageable'
}, {
  name: 'POST /partner/update',
  back: {
    url: 'POST /partner/update',
    controller: 'PartnerController',
    action: 'update'
  },
  type: 'notManageable'
}, {
  name: 'DELETE /partner/delete',
  back: {
    url: 'DELETE /partner/delete',
    controller: 'PartnerController',
    action: 'delete'
  },
  type: 'notManageable'
}, {
  name: "fetchPartnerImage",
  back: {
    url: "GET /uploaded/partner-logo/:partnerId/:name",
    controller: "PartnerController",
    action: "fetchPartnerImage",
    skipAssets: false
  },
  type: "public"
}, /* ------------------------- Blog ------------------------- */

{
  name: 'GET /contenu/liste-des-ressources',
  CODE: 'AdminBlogsDashboard',
  front: {
    url: '/contenu/liste-des-ressources',
    reactComponent: 'BlogsDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /contenu/liste-des-ressources/nouvelle-ressource',
  CODE: 'NewBlog',
  front: {
    url: '/contenu/liste-des-ressources/nouvelle-ressource',
    reactComponent: 'NewBlogPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /contenu/liste-des-ressources/:id',
  front: {
    url: '/contenu/liste-des-ressources/:id',
    reactComponent: 'UpdateBlogPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /blog/get-all',
  back: {
    url: 'POST /blog/get-all',
    controller: 'BlogController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /blog/create',
  back: {
    url: 'POST /blog/create',
    controller: 'BlogController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /blog/update',
  back: {
    url: 'POST /blog/update',
    controller: 'BlogController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'DELETE /blog/delete',
  back: {
    url: 'DELETE /blog/delete',
    controller: 'BlogController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, {
  name: "fetchBlogImage",
  back: {
    url: "GET /uploaded/image/:blogId/:name",
    controller: "BlogController",
    action: "fetchBlogImage",
    skipAssets: false
  },
  type: "public"
}, {
  name: "fetchBlogDocument",
  back: {
    url: "GET /uploaded/document/:blogId/:name",
    controller: "BlogController",
    action: "fetchBlogDocument",
    skipAssets: false
  },
  type: "public"
}, {
  name: 'GET /contenu/liste-des-actualites',
  CODE: 'AdminNewsDashboard',
  front: {
    url: '/contenu/liste-des-actualites',
    reactComponent: 'NewsDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /contenu/liste-des-actualites/nouvelle-actualite',
  CODE: 'NewNews',
  front: {
    url: '/contenu/liste-des-actualites/nouvelle-actualite',
    reactComponent: 'NewNewsPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /contenu/liste-des-actualites/:id',
  front: {
    url: '/contenu/liste-des-actualites/:id',
    reactComponent: 'UpdateNewsPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /news/get-all',
  back: {
    url: 'POST /news/get-all',
    controller: 'NewsController',
    action: 'getAll'
  },
  type: 'public'
}, {
  name: 'POST /news/create',
  back: {
    url: 'POST /news/create',
    controller: 'NewsController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /news/update',
  back: {
    url: 'POST /news/update',
    controller: 'NewsController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'DELETE /news/delete',
  back: {
    url: 'DELETE /news/delete',
    controller: 'NewsController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, {
  name: 'fetchNewsImage',
  back: {
    url: 'GET /actualite/image/:newsId/:name',
    controller: 'NewsController',
    action: 'fetchNewsImage',
    skipAssets: false
  },
  type: 'public'
}, {
  name: 'fetchNewsDocument',
  back: {
    url: 'GET /actualite/document/:newsId/:name',
    controller: 'NewsController',
    action: 'fetchNewsDocument',
    skipAssets: false
  },
  type: 'public'
},
/*
	========================================================
	------------------------- Auth -------------------------
	========================================================
*/
{
  name: 'POST /get-session',
  back: {
    url: 'POST /get-session',
    controller: 'SessionController',
    action: 'get'
  },
  type: 'public'
}, {
  name: 'POST /login',
  back: {
    url: 'POST /login',
    controller: 'AuthController',
    action: 'login'
  },
  type: 'public'
}, {
  name: 'POST /logout',
  back: {
    url: 'POST /logout',
    controller: 'AuthController',
    action: 'logout'
  },
  type: 'public'
}, {
  name: 'GET /authentification/mot-de-passe-oublie',
  CODE: 'PasswordRecovery',
  front: {
    url: '/authentification/mot-de-passe-oublie',
    reactComponent: 'PasswordRecoveryPage'
  },
  type: 'public'
}, {
  name: 'GET /authentification/mot-de-passe-oublie/nouveau-mot-de-passe',
  CODE: 'ForgottenPassword',
  front: {
    url: '/authentification/mot-de-passe-oublie/nouveau-mot-de-passe',
    reactComponent: 'ForgottenPasswordPage'
  },
  type: 'public'
}, {
  name: 'POST /user/recover-password',
  back: {
    url: 'POST /user/recover-password',
    controller: 'AuthController',
    action: 'recoverPassword'
  },
  type: 'public'
}, {
  name: 'POST /token/verify-password-recovery-token',
  back: {
    url: 'POST /token/verify-password-recovery-token',
    controller: 'TokenController',
    action: 'verifyPasswordRecovery'
  },
  type: 'public'
}, {
  name: 'POST /user/new-password',
  back: {
    url: 'POST /user/new-password',
    controller: 'AuthController',
    action: 'newPassword'
  },
  type: 'public'
}, {
  name: 'POST /migrations/candidates-monitoring',
  back: {
    url: 'POST /migrations/candidates-monitoring',
    controller: 'MigrationController',
    action: 'fixCandidatesMonitorings'
  },
  type: 'adminOnly'
}];
module.exports.front_urls = module.exports.routes.filter(route => route.CODE && route.front && route.front.url).map(function (route) {
  return {
    CODE: route.CODE,
    url: route.front.url
  };
});
module.exports.URL = function (CODE, routes) {
  return ((routes || module.exports.front_urls).find(data => data.CODE === CODE) || {}).url;
};
